import { faPhoneVolume } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, TextField } from '@mui/material';
import { InputLabelProps } from "common/DatePicker";
import React, { useCallback, useContext, useState } from 'react';
import Card from 'common/card/Card';
import CardBody from 'common/card/CardBody';
import CardHead from 'common/card/CardHead';
import 'styles/index.css';
import { NotificationContext } from './Notification';
import { callClient } from 'services/caller_service';
import { handleError } from 'services/api';
import { ApiError } from 'data/api_error';
import { ApiResponse } from 'data/response';
import { Message } from 'data/message';
import { AuthenticationContext } from './providers/AuthCtx';

function useCaller(): [string, any, () => void] {
    const authCtx = useContext(AuthenticationContext);
    const notificationHandler = useContext(NotificationContext);
    const [number, setNumber] = useState("");

    const call = useCallback(() => {
        if (number === "") {
            return;
        }

        callClient(authCtx, number).then((res: ApiResponse<Message>) => {
            notificationHandler({
                type: "success",
                message: res.data.message,
                timeout: 4000,
            });
            setNumber("");
        }).catch((e: ApiError) => {
            handleError(e, notificationHandler);
        });
    }, [authCtx, number, notificationHandler]);

    return [number, setNumber, call];
}

const Home: React.FC = () => {
    const [number, setNumber, call] = useCaller();

    return (
        <div className="container">
            <div style={{ gridArea: "card" }}>
            <Card>
                <CardHead>
                    <FontAwesomeIcon icon={faPhoneVolume}></FontAwesomeIcon>
                </CardHead>
                <CardBody>
                    <TextField
                        InputLabelProps={InputLabelProps}
                        label="Numéro du client"
                        variant="standard"
                        value={number}
                        disabled={false}
                        error={false}
                        onChange={(e) => setNumber(e.target.value)}></TextField>
                    <Button
                        disabled={number === ""}
                        onClick={() => call()}
                        variant="outlined"
                        style={{minWidth: "200px"}}
                        color="secondary">Appeler</Button>
                </CardBody>
            </Card>
            </div>
        </div>
    )
}

export default Home
